module.exports = __webpack_public_path__ + "img/img_web04_zshu1.ee2f4d0e.jpg";